import React, { ReactNode, ReactElement } from "react";
import { Modal, Space } from "@arco-design/web-react";
import "./index.less";

interface IModalProps {
  width?: number | string;
  height?: number | string;
  title?: string;
  children: ReactNode;
  titleIcon?: ReactElement;
  closeIcon?: ReactElement;
  visible?: boolean;
  cancelBtn?: ReactElement;
  subMiteBtn?: ReactElement;
  style?: React.CSSProperties;
  handleCancel?: () => void;
  showFooter?: boolean;
  alignCenter?: boolean;
  footer?: ReactElement;
  closable?: boolean;
}

const Modals: React.FC<IModalProps> = (props) => {
  const {
    width,
    height,
    title,
    children,
    titleIcon,
    closeIcon,
    visible,
    cancelBtn,
    style = {},
    subMiteBtn,
    handleCancel,
    alignCenter = true,
    showFooter,
    closable = true,
    footer = null,
    ...item
  } = props;
  return (
    <Modal
      title={null}
      style={{ width: width, height: height, ...style }}
      footer={null}
      closable={closable}
      focusLock={false}
      autoFocus={false}
      visible={visible}
      alignCenter={alignCenter}
      onCancel={handleCancel}
      {...item}>
      <div className="creation-modal">
        <div className="modal-header">
          <div className="moadl-title">
            <div>
              {titleIcon}
              <span>{title}</span>
            </div>
            <div>{closeIcon}</div>
          </div>
        </div>
        <div>{children}</div>
        <div className="matrix-modal-footer">
          {footer ? (
            footer
          ) : (
            <>
              {showFooter && (
                <div className="modal-footer-btn">
                  <Space>
                    {cancelBtn}
                    {subMiteBtn}
                  </Space>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Modals;
